import gsap from "gsap";

export default function PageTransition() {
  const curtain = document.getElementById("pt-curtain");
  const settings = {
    ease: "power4.out",
    duration: 0.7,
  };

  if (!curtain) return;

  // Enter: arriving from a page transition — curtain is covering screen, sweep it down to reveal
  if (document.documentElement.classList.contains("pt-entering")) {
    gsap.fromTo(
      curtain.children[0],
      { autoAlpha: 1, yPercent: 0 },
      {
        duration: settings.duration,
        // autoAlpha: 0,
        yPercent: -100,
        ease: settings.ease,
        onComplete: () =>
          document.documentElement.classList.remove("pt-entering"),
      },
    );

    gsap.fromTo(
      document.querySelector("main"),
      { y: "15vh", opacity: 0 },
      {
        duration: settings.duration,
        y: "vh",
        opacity: 1,
        // delay: 0.15,
        clearProps: "all",
        ease: settings.ease,
      },
    );

    // gsap.fromTo(
    //   curtain.children[0],
    //   { autoAlpha: 1 },
    //   {
    //     duration: settings.duration,
    //     autoAlpha: 0,
    //     delay: 0,
    //     ease: settings.ease,
    //     onComplete: () =>
    //       document.documentElement.classList.remove("pt-entering"),
    //   },
    // );
  } else {
    gsap.set(curtain, { autoAlpha: 0 });
  }

  // Back/forward from BFCache — curtain is frozen mid-cover, sweep it away
  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      gsap.set(curtain, { autoAlpha: 0 });
      gsap.set(document.querySelector("main"), {
        y: "0",
        opacity: 1,
      });
    }
  });

  // Exit: intercept same-origin navigation links
  document.addEventListener("click", (e) => {
    const anchor = e.target.closest("a");
    if (!anchor || anchor.hasAttribute("download")) return;

    const href = anchor.getAttribute("href");
    if (
      !href ||
      href.startsWith("#") ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:") ||
      anchor.target === "_blank" ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey
    )
      return;

    // Skip external links
    if (anchor.hostname && anchor.hostname !== location.hostname) return;

    e.preventDefault();
    sessionStorage.setItem("pt", "1");

    // Start fetching the next page immediately — in parallel with the animation.
    // By the time the curtain finishes, the response is usually already cached,
    // so location.assign() gets a near-instant cache hit instead of a cold request.
    const fetchPromise = fetch(href, { credentials: "same-origin" }).catch(
      () => null,
    );

    gsap.set(curtain, { autoAlpha: 1 });

    gsap.fromTo(
      document.querySelector("main"),
      { y: "0vh" },
      {
        duration: settings.duration,
        y: "-15vh",
        opacity: 0,
        ease: settings.ease,
        onComplete: () =>
          document.documentElement.classList.remove("pt-entering"),
      },
    );

    const animationPromise = new Promise((resolve) => {
      gsap.fromTo(
        curtain.children[0],
        { yPercent: 100 },
        {
          yPercent: 0,
          duration: settings.duration,
          ease: settings.ease,
          onComplete: resolve,
        },
      );
    });

    Promise.all([fetchPromise, animationPromise]).then(() =>
      location.assign(href),
    );
  });
}
